import Validations from "./validations.js.erb"
import BaseValidator from "./base_validator"
import PresenceValidator from "./presence_validator"
import LengthValidator from "./length_validator"
import NumericalityValidator from "./numericality_validator"
import FormatValidator from "./format_validator"
import UniquenessValidator from "./uniqueness_validator"
import ConfirmationValidator from "./confirmation_validator"

let validators = {
  presence: PresenceValidator,
  numericality: NumericalityValidator,
  length: LengthValidator,
  format: FormatValidator,
  uniqueness: UniquenessValidator,
  confirmation: ConfirmationValidator
}

export class Validation {
  validatable(input_id) {
    return Validations[input_id] !== undefined
  }

  validate(value, id, newRecord, element = null) {
    let validations = Validations[id]
    let results = validations.map((validation) => {
      if (this.skippable(validation, value)) {
        return { validator: validation.validator, result: { valid: true, message: '' } }
      }

      let validator = new validators[validation.validator](value, validation.options, validation.error_messages, id, newRecord, element)
      return { validator: validation.validator, result: validator.validate() }
    });

    return results
  }

  // Respeta el allow_blank de Rails: sin esto un campo vacio reporta a la vez "obligatorio" y
  // "formato invalido", y la unicidad consultaria al servidor por un valor que no existe.
  skippable(validation, value) {
    if (!validation.options || !validation.options.allow_blank) return false

    return value === null || value === undefined || String(value).trim() === ''
  }
}
